import { render, staticRenderFns } from "./pressreleaseDetail.vue?vue&type=template&id=d01be0ea&scoped=true&"
import script from "./pressreleaseDetail.vue?vue&type=script&lang=js&"
export * from "./pressreleaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./pressreleaseDetail.vue?vue&type=style&index=0&id=d01be0ea&scoped=true&lang=scss&"
import style1 from "./pressreleaseDetail.vue?vue&type=style&index=1&id=d01be0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01be0ea",
  null
  
)

export default component.exports